import React from 'react'
import styled from 'styled-components'
import {
  Tab as ReactTab,
  Tabs as ReactTabs,
  TabList as ReactTabList,
  TabPanel as TabPanelContainer,
} from 'react-tabs'

import { mediaqueries } from '~/utils/mediaqueries'
import { Brevier } from '~/components/Typography'

const Box = styled.div`
  padding: 25px 20px;
  border-radius: 6px;
  background: ${({ theme: { color } }) => color('accent', 70)};
  width: calc(100%);
  margin: 0 10px 30px;
  align-self: flex-end;

  @media ${mediaqueries.md} {
    width: 100%;
    margin-bottom: 0px;
  }
`

const Tabs = styled(ReactTabs)``

const Tab = styled(ReactTab)`
  padding: 0 8px;
  cursor: pointer;
  position: relative;
  &:before {
    content: '';
    height: 1px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2px;
    background: inherit;
  }

  &.react-tabs__tab--selected {
    text-decoration: underline;
  }
`

const TabList = styled(ReactTabList)`
  display: flex;
  margin: 0 -8px;
`

const ContentP = styled(Brevier)`
  padding-top: 20px;
  padding-right: 30px;
  font-size: 11px !important;
  min-height: 110px;
  strong {
    font-weight: 800 !important;
  }

  a {
    color: inherit;
  }
`

const TABS = [
  {
    name: 'Info',
    content: () => (
      <ContentP>
        <strong>Lav, forhåndsvis, og bestil.</strong>
        <br />
        Vores unikke designtool giver dig mulighed for at designe din helt egen plakat
        - vælg selv bogstav, stil, farve, bogstavets størrelse, plakatstørrelse og tilføj en personlig
        tekst. Det kan fx være barnets navn og fødselsdato. Når du er færdig og afslutter købet i checkout printer vi din plakat og sender den hjem til dig!
      </ContentP>
    ),
  },
  {
    name: 'Detaljer',
    content: () => (
      <ContentP>
        <strong>Plakatstørrelse:</strong> Du kan vælge mellem 30×40cm, 50×70cm,
        70x100cm og 100x150cm
        <br />
        <br />
        <strong>Papirkvalitet:</strong> 240 g/m2 syrefrit matpapir
        <br />
        <br />
        <strong>Forsendelse:</strong> Gratis fragt til hele verden
      </ContentP>
    ),
  },
  {
    name: 'Forsendelse',
    content: () => (
      <ContentP>
        Gratis worldwide forsendelse inkl. tracking af din pakke: 5-10 hverdage.
        <br />
        <br />
        Worldwide ekspresforsendelse: 3-5 hverdage.
      </ContentP>
    ),
  },
  {
    name: 'Sprøgsmål og svar',
    content: () => (
      <ContentP>
        <strong>
          Kan jeg ændre plakatdesign og informationer, når jeg allerede har
          bestilt plakaten?
        </strong>
        <br />
        Ja, med standardforsendelse har du op til 6 timer til at rediger din
        plakat efter købet. Med ekspresforsendelse er tidsfristen 1 time.
        <br />
        <br />
        <strong>Kan man købe et gavekort?</strong> <br />
        Ja.{' '}
        <a href="https://typeandmore.dk/pages/need-help-were-here-for-you">
          Kontakt os her
        </a>
        , hvis du ønsker at købe et gavekort.
        <br />
        <br />
        <strong>Sendes plakaten fladt eller rullet sammen?</strong>
        <br />
        Hvis du kun bestiller en plakat, leveres den rullet i et rør. Hvis du
        bestiller en plakat sammen med en ramme, sendes den fladt.
      </ContentP>
    ),
  },
]

export const InfoBox = ({ title, content }) => (
  <Box>
    <Tabs>
      <TabList>
        {TABS.map(({ name }, key) => (
          <Tab key={key}>
            <Brevier>{name}</Brevier>
          </Tab>
        ))}
      </TabList>
      {TABS.map(({ content: Content }, key) => (
        <TabPanelContainer key={key}>
          <Content />
        </TabPanelContainer>
      ))}
    </Tabs>
  </Box>
)
